var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-switcher d-flex jcb aic"},[(_vm.label)?_c('div',{staticClass:"text-grey"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('a-switch',{attrs:{"checked":_vm.value,"disabled":_vm.disabled},on:{"change":function($event){return _vm.$emit('change', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }